import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function ThemeLoader() {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-white">
      <div className="relative flex flex-col items-center justify-center gap-6">
        <div className="relative flex items-center justify-center">
          <div className="absolute inset-0 border-4 border-gray-100 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-gray-800 rounded-full border-t-transparent animate-spin"></div>
          <div className="w-16 h-16 flex items-center justify-center">
            <Loader2 className="w-6 h-6 text-gray-800 animate-pulse" />
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-xl font-semibold text-gray-800 tracking-tight">{t('common.themeLoader.preparing')}</h2>
          <p className="text-sm font-medium text-gray-500 animate-pulse">{t('common.themeLoader.loadingTheme')}</p>
        </div>
      </div>
    </div>
  )
}
